import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint } from '../../../constants/routes'

class TripsIndex extends React.Component {
    state = {}

    componentDidMount = () => {
        this.props.dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('luna-trip', 'LIST')))
    }

    renderTrips = () => {
        const { trips } = this.props
        let allTrips = []
        trips.forEach(trip => {
            allTrips.push(
                <tr key={trip.get('id')}>
                    <td>{trip.get('id')}</td>
                    <td>{trip.get('name')}</td>
                    <td>{moment(trip.get('createdOn')).format('ddd MMM D, Y hh:mma')}</td>
                </tr>
            )
        })

        if (allTrips.length === 0) {
            return null
        }
        return (
            <table className="table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Trip Name</th>
                        <th>Created On</th>
                    </tr>
                </thead>
                <tbody>
                    {allTrips}
                </tbody>
            </table>
        )
    }

    render = () => {
        return (
            <div>
                {this.renderTrips()}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        trips: state.trips.sort((a, b) => {
            if (a.id > b.id) {
                return -1
            }
            return 1
        })
    }
}

export default connect(mapStateToProps)(TripsIndex)
